import { useEnvironmentStore } from "@/stores/environmentStore";
import { readonly, ref } from "vue";

const POLLING_INTERVAL_MS = 60 * 1000;

const pendingServerUpdate = ref(false);

let pollIntervalId: ReturnType<typeof setInterval> | undefined;
let isPolling = false;

async function checkForUpdates() {
  const environmentStore = useEnvironmentStore();

  try {
    const updateAvailable = await environmentStore.checkForUpdates();
    pendingServerUpdate.value = updateAvailable;
  } catch (error) {
    logError(error, {
      context: {
        feature: "version-checker",
        step: "checkForUpdates",
      },
    });
    console.error("Error checking for updates:", error);
  }
}

function startPolling() {
  if (isPolling) return;

  isPolling = true;
  void checkForUpdates();
  pollIntervalId = setInterval(() => {
    void checkForUpdates();
  }, POLLING_INTERVAL_MS);
}

function stopPolling() {
  if (!isPolling) return;
  if (!pollIntervalId) {
    isPolling = false;
    return;
  }

  clearInterval(pollIntervalId);
  pollIntervalId = undefined;
  isPolling = false;
}

function markPendingServerUpdate() {
  pendingServerUpdate.value = true;
}

export function useVersionUpdatePolling() {
  return {
    pendingServerUpdate: readonly(pendingServerUpdate),
    startPolling,
    stopPolling,
    markPendingServerUpdate,
  };
}
